<script setup lang="ts">
import dayjs from "dayjs";
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {massCertificationApi} from "@/container";
import {Skeleton} from "@/core/components/ui/skeleton";
import Icon from "@/core/components/icon/Icon.vue";

const params = {
    query: {
        "minimum_visits": [1],
        "last_visit_range": [{
            from: dayjs().format('YYYY-MM-DD'),
            to: null
        }]
    },
    limit: 0
};

const {data} = useSwr(
    cacheKey('mass-certification/customers', params),
    () => massCertificationApi().customers(params)
);
</script>

<template>
  <router-link :to="{name: 'patient-administration.application'}" class="w-full h-full">
    <div class="flex border-primary border-[2px] px-4 py-2 rounded-lg justify-between h-full hover:opacity-75">
      <div v-if="!data" class="w-full h-full flex flex-col justify-between">
        <Skeleton class="w-full h-4 max-w-32" />
        <Skeleton class="w-full h-4 mt-1 max-w-44" />
      </div>
      <div v-else>
        <p v-if="data?.meta?.total === 0" class="text-primary font-bold">
          Aucun patient n'est venu aujourd'hui
        </p>
        <p v-else class="text-primary font-bold">
          {{ data?.meta.total }}
          {{ (data?.meta?.total ?? 0) > 1 ? "patients sont venus aujourd'hui" : "patient est venu aujourd'hui" }}
        </p>
        <p v-if="data?.meta.total > 0" class="text-sm">
          {{
            data.meta.total > 1 ? 'Aidez les à bien prendre leurs médicaments' : 'Aidez le à bien prendre ses médicaments'
          }}
        </p>
        <p v-else class="text-sm">
          Découvrez comment aider vos patients à bien prendre leurs médicaments
        </p>
      </div>
      <Icon name="mdi-chevron-right" :size="30" color="primary" class="self-center ml-4" />
    </div>
  </router-link>
</template>
